module.exports = __webpack_public_path__ + "assets/img/Ultimate-Ears-Social-Static-Ad.966d6fd9.png";